import { useEffect, useState } from 'react'
import { Image as ImageIcon } from 'lucide-react'
import { fetchPhotos, type LifePhotoEntry } from '../lib/api'
import LifeModal from '../components/LifeModal'

export default function PhotosSection() {
  const [items, setItems] = useState<LifePhotoEntry[]>([])
  const [active, setActive] = useState<LifePhotoEntry | null>(null)

  useEffect(() => {
    fetchPhotos().then(setItems)
  }, [])

  return (
    <section id="photos" className="scroll-mt-32 py-16">
      <header className="mb-8 flex items-end justify-between gap-4">
        <div>
          <h2 className="text-4xl font-heading font-semibold amber-gradient-text">Photos</h2>
          <p className="text-amber-100/70 mt-1 max-w-prose">
            Frames from elsewhere — light, texture, the small things.
          </p>
        </div>
        <ImageIcon className="text-amber-300/60" size={28} />
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((p, i) => (
          <button
            key={p.id}
            onClick={() => setActive(p)}
            className={`life-card rounded-xl overflow-hidden text-left group ${i === 0 ? 'col-span-2 lg:col-span-3' : ''}`}
          >
            <div className={`bg-navy-800 overflow-hidden ${i === 0 ? 'aspect-[16/9]' : 'aspect-[4/3]'}`}>
              <img
                src={`/media/${p.image}`}
                alt={p.caption}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <p className={`text-amber-100/85 leading-relaxed ${i === 0 ? 'text-base' : 'text-sm'}`}>{p.caption}</p>
              {p.taken && (
                <p className="text-xs text-amber-200/50 mt-1">{p.taken}</p>
              )}
            </div>
          </button>
        ))}
      </div>

      <LifeModal
        isOpen={active !== null}
        onClose={() => setActive(null)}
        title={active?.caption ?? ''}
        size="xl"
      >
        {active && (
          <div className="p-6 space-y-4">
            <div className="rounded-lg overflow-hidden bg-black/40">
              <img
                src={`/media/${active.image}`}
                alt={active.caption}
                className="w-full h-auto max-h-[70vh] object-contain"
              />
            </div>
            <div className="flex items-center justify-between text-sm text-amber-200/70">
              {active.location && <span>{active.location}</span>}
              {active.taken && <span>{active.taken}</span>}
            </div>
          </div>
        )}
      </LifeModal>
    </section>
  )
}
